// 🆕🚪 "New! Try /room" — the composer hint's retire logic (Nina 09-18).
// Per DEVICE, house spaces only: the hint shows until the viewer uses /room
// once (typed, a picker row, or the door), or HINT_DAYS after they first saw
// it — the same window as the What's New dot, so "New!" never goes stale.
// localStorage is a per-viewer convenience that can be missing, blocked or
// full: every read/write is guarded and the page renders correctly without it
// (a device that cannot remember simply keeps seeing the hint).
export const HINT_KEY = 'room_new_hint_v1';
export const HINT_DAYS = 14;
const DAY_MS = 86400e3;

function read(store) {
  try {
    const raw = store && store.getItem(HINT_KEY);
    const v = raw ? JSON.parse(raw) : null;
    return v && typeof v === 'object' ? v : {};
  } catch (e) { return {}; }
}
function write(store, v) {
  try { if (store) store.setItem(HINT_KEY, JSON.stringify(v)); } catch (e) { /* dropped on purpose */ }
}

/** Should the hint show on this device right now? */
export function roomHintLive(store, nowMs) {
  const v = read(store);
  if (v.used) return false;
  if (Number.isFinite(v.first) && nowMs - v.first > HINT_DAYS * DAY_MS) return false;
  return true;
}

/** Start the clock the first time the hint is actually on screen. Never
 *  restarts it, never un-retires a used hint. */
export function roomHintSeen(store, nowMs) {
  const v = read(store);
  if (v.used || Number.isFinite(v.first)) return;
  write(store, { ...v, first: nowMs });
}

/** The viewer used /room: retire the hint for good. */
export function roomHintUsed(store, nowMs) {
  const v = read(store);
  if (v.used) return;
  write(store, { ...v, used: nowMs });
}

/** The browser store, or null where there is none (SSR, blocked storage). */
export function hintStore() {
  try { return typeof window !== 'undefined' ? window.localStorage : null; } catch (e) { return null; }
}
